/*******************************************************************************
  SiteInspectionConfig.js

  Author: Advait

*******************************************************************************/
import React, {Component} from 'react'
import SelectSite from '../components/SelectSite'
import '../index.css'

class SiteInspectionConfig extends Component{
  render(){
    return (
      <div className="fullPageDiv">
        <h3>Inspection Mode Configuration</h3>
        <SelectSite pageType ="roundConfig" scheduleType ="inspection"/>
      </div>

    
    )
  }
}
export default SiteInspectionConfig
